import React from 'react'
import { FormProvider } from '@/providers';
import NewMapChange from '@/Pages/NewMapChange';

export const MapListingFragment = () => {


    return (
        <FormProvider>
            <NewMapChange />
        </FormProvider>
    )
}
